import { GET_PAGINATED_DOCUMENTS} from '@/store/modules/documents/action_types'

import { DocumentsCreateNewFolderActionTypes } from './action_types'
import { DocumentsCreateNewFolderMutationTypes } from './mutation_types'
import documentsService from '../../../services/documents.service'

export const actions: StoreActions<DocumentsCreateNewFolderActionTypes, DocumentsCreateNewFolderMutationTypes> = {
  [DocumentsCreateNewFolderActionTypes.OPEN_DOCUMENTS_CREATE_NEW_FOLDER]: function ({ commit }) {
    commit('SET_IS_OPEN', true)
  },
  [DocumentsCreateNewFolderActionTypes.CLOSE_DOCUMENTS_CREATE_NEW_FOLDER]: function ({ commit }) {
    commit('SET_LOADING', false)
    commit('SET_IS_OPEN', false)
  },
  [DocumentsCreateNewFolderActionTypes.CREATE_DOCUMENTS_NEW_FOLDER]: function ({ commit, rootGetters, rootState, dispatch }, newFolderName) {
    commit('SET_LOADING', true)
    // This is a TypeScript workaround to access the root documents state
    const documentsState = (rootState as any)['documents']
    const data = {
      name: newFolderName,
      parentId: documentsState?.paginatedDocuments ? documentsState.paginatedDocumentsCurrentFolderId : undefined,
    }
    return documentsService.createNewFolder(rootGetters['room/roomMnemo'], data)
      .then(() => {
        dispatch(`documents/${GET_PAGINATED_DOCUMENTS}`, undefined, { root: true })
        commit('SET_IS_OPEN', false)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
      })
  },
}
